import { sharedFriendsService, PresenceService, CurrentUser } from 'Roblox';
import angular from 'angular';
import chatModule from '../chatModule';

function chatFriendsService($log, friendsInfoService) {
  'ngInject';

  return {
    initializeFriends: (chatLibrary, callback, forceUpdate) => {
      if (forceUpdate) {
        sharedFriendsService.isInitialized = false;
      }
      const {
        isUsingCacheToLoadFriendsInfoEnabled,
        cachedDataFromLocalStorageExpirationMS
      } = chatLibrary;
      const cacheCriteria = {
        isEnabled: forceUpdate ? false : isUsingCacheToLoadFriendsInfoEnabled,
        expirationMS: cachedDataFromLocalStorageExpirationMS
      };
      sharedFriendsService.register(callback, cacheCriteria);
    }
  };
}

chatModule.factory('chatFriendsService', chatFriendsService);

export default chatFriendsService;
